export const METRICS = [
    "retiradasRequisicoes",
    "consumoEpiFunc",
    "rankingProdutos",
    "consumoEPI",
    "totalEpisVencidos",
    "vencimentoCAperiodo",
    "CAVencidos",
    "equipDisconnect",
    "equipamentoEstoqueBaixo",
    "requisicoesArea",
];


export const PERIOD_OPTIONS = [
    { label: "7 dias",  value: 7  },
    { label: "30 dias", value: 30 },
    { label: "90 dias", value: 90 },
];

export const COLORS = {
    g1: "#1e5139",
    g2: "#639922",
    g3: "#97C459",
    g4: "#C0DD97",

    tPri: "#1e5139",
    tSec: "#2D5016",
    tDim: "#4A6B38",

    amber: "#7A4A08",
    red: "#7A1F1F",

    kpiBg: "#F0F5EB",
    kpiBgWarn: "#FDF8EC",
    kpiBgDanger: "#FCEAEA",

    badgeBgOk: "#DFF0CC",
    badgeBgWarn: "#FAEEDA",
    badgeBgDanger: "#FCEAEA",

    bg: "#F4F6F3",
    card: "#FFFFFF",
    border: "#D6E0D0",

    chartLine1: "#1e5139",
    chartLine2: "#97C459",
    chartBar1: "#1e5139",
    chartBar2: "#268e5c",
    chartDim: "#C0DD97",
};

export const PIE_COLORS = ["#1e5139", "#268e5c", "#83dfb0", "#47c588"];

export const MES_LABELS = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];